import { useEffect, useRef, useState } from "react";

import { logout } from '../../auth';
import { post } from '../../services/api';

import AdminTable from "../../components/AdminTable/AdminTable";
import AdminSwitch from "../../components/AdminSwitch/AdminSwitch";

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import "./TabelaHabilitarRegioes.css"

export default function TabelaHabilitarRegioes({
    filtros,
    regioes,

    setNotifier
}) {
    //Componentes reutilizados
    const iconeSubTabelaFechada = <KeyboardArrowRightIcon style={{width: '25px', height: '25px', cursor: 'pointer'}} />;
    const iconeSubTabelaAberta = <KeyboardArrowDownIcon style={{width: '25px', height: '25px', cursor: 'pointer'}} />;

    //Data
    const [ dados, setDados ] = useState(null);
    const tableData = {
        atributoKey: 'id_regiao',
        colunas: [
            { nome: '', atributo: 'iconeSubTabela', style: {width: '72px'} },
            { nome: 'ID', atributo: 'id_regiao', style: {width: '80px'} }, 
            { nome: 'Região', atributo: 'regiao_nome' }, 
            { nome: 'Habilitar', atributo: 'habilitada', style: {width: '92px'} }
        ],
        dados: dados,

        temSubtabela: true
    };

    //Preencher data quando regiões forem atualizadas
    useEffect(() => {
        popularDadosTabela();

        //Usado para focar na filial filtrada
        if(filtros.id_filiais != 0) setTimeout(focarFilialConsultada);
        
    }, [ regioes ]);
    
    function popularDadosTabela() {
        if(typeof regioes !== 'undefined' && regioes !== null){
            setDados(regioes.map((regiao, index) => {
                const isSubTabelaAberta = 
                    filtros.id_filiais != 0 && 
                    regiao.filiais.map(f => f.id_filial).includes(filtros.id_filiais);

                const row = {
                    iconeSubTabela: isSubTabelaAberta ? iconeSubTabelaAberta : iconeSubTabelaFechada,
                    iconeSubTabela_onClick: () => abrirSubtabela(index),
    
                    id_regiao: regiao.id_regiao,
                    regiao_nome: regiao.regiao_nome,
                    habilitada: <AdminSwitch defaultChecked={regiao.habilitada} 
                        onChange={(event) => habilitarHandler(regiao.id_regiao, event.target.checked)}
                    />,
    
                    subtabelaAberta: isSubTabelaAberta,
                    subtabela: {
                        atributoKey: 'id_filial',
                        colunas: [
                            { nome: 'ID', atributo: 'id_filial', style: {width: '128px'} }, 
                            { nome: 'Filial', atributo: 'filial_nome' }
                        ],
                        dados: regiao.filiais.map(filial => ({
                            id_filial: filial.id_filial - 10000,
                            filial_nome: filial.filial_nome,
                            rowRef: filial.id_filial == filtros.id_filiais 
                                ? filialFiltradaRef
                                : undefined,
                            className: filial.id_filial == filtros.id_filiais
                                ? 'filial-regiao-filtrada'
                                : ''
                        }))
                    }
                }

                return row;
            }));
        }
    }

    function focarFilialConsultada() {
        if (filialFiltradaRef.current) {
            filialFiltradaRef.current.scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
                window.scrollBy(0, -200);
            }, 500);
        }
    }

    //Utils
    const filialFiltradaRef = useRef(null);

    //Actions
    function abrirSubtabela(indexRow) {
        setDados((oldDados) => oldDados.map((row, index) => {
            if(indexRow == index){
                row.subtabelaAberta = !row.subtabelaAberta;
                
                row.iconeSubTabela = row.subtabelaAberta 
                    ? iconeSubTabelaAberta
                    : iconeSubTabelaFechada;
            }
            
            return row;
        }));
    }

    async function habilitarHandler(id_regiao, habilitar) {
        const idUsuarioAtual = localStorage.getItem("idusuario");
        const authToken = localStorage.getItem("adminToken");

        if(typeof idUsuarioAtual === 'undefined') {
            logout();
        } else{
            const requisicao = {
                id_regiao: id_regiao,
                habilitar: habilitar,
                id_usuario: Number(idUsuarioAtual)
            }

            const { response } = await post('/admin/parametrizacao/regioeshabilitadas', requisicao, authToken);

            if(response?.status >= 400){
                console.log(setNotifier)
                setNotifier(false, response.data.Error);
            }
        }
    }

    return <>
        <AdminTable
            atributoKey={tableData.atributoKey}
            colunas={tableData.colunas}
            dados={tableData.dados}
            temSubtabela={true}
            styleName={'tabela-habilitar-regioes'}
        />
    </>
}